<template>
  <div class="policy">

    <div class="hero-block__wrap">
      <h1 class="hero-block__title">Area Legale</h1>
    </div>

    <div class="istit__content">
      <div class="istit__content__inner">

        <h2>Cookies Policy</h2>
        <p><strong>DICHIARAZIONE DEI COOKIE</strong><br />
        Questo sito internet, www.pololab.com, utilizza i cookie e strumenti analoghi per garantire il funzionamento dei servizi erogati, per salvare le preferenze di navigazione degli Utenti ed ottimizzare e verificare l'esperienza di navigazione dell’Utente. Accedendo al Sito, l’Utente acconsente all’uso dei cookie da parte di Pololab in conformità a quanto previsto di seguito.
        </p>
        <p><strong>COSA SONO I COOKIE</strong><br />
        I cookie sono piccoli file di testo in formato alfanumerico che possono venire salvati sul computer dell'Utente (o su altri dispositivi abilitati alla navigazione in internet, per esempio smartphone o tablet) quando esso visita i Siti Web.<br>
        I cookie possono essere usati dai web server per identificare e rintracciare gli Utenti durante la navigazione tra le diverse pagine del Sito ed identificare quelli che ne fanno ritorno. I cookie facilitano la navigazione dell’Utente e forniscono connessioni protette.<br>
        I cookie possono essere di sessione e permanenti e la loro distinzione può essere effettuata in ragione della loro persistenza sul terminale dell’Utente. Quelli che si cancellano automaticamente alla fine di ogni navigazione, si chiamano cookie di sessione (ad esempio possono ricordare i beni e servizi inseriti dall’Utente nel carrello virtuale). Se viceversa essi hanno una vita più lunga, si parla di cookie permanenti (ad esempio possono ricordare le preferenze personali impostate dall’Utente).
        </p>
        <p><strong>FINALITÀ DELL’UTILIZZO DEI COOKIE</strong><br />
        I cookie non contengono alcuna informazione che possa identificare l’Utente personalmente (quali ad esempio nome, cognome, indirizzi email, numeri di telefono).<br><br>
        Le informazioni derivanti dalla navigazione dell’Utente all’interno del Sito, e raccolte per mezzo dei cookie, possono essere usate da Pololab per le seguenti finalità:<br>
        analizzare l’uso e le prestazioni del Sito, compresi i messaggi di posta elettronica, in modo da fornire un’esperienza di alta qualità all’Utente, identificare e risolvere rapidamente gli eventuali problemi che si presentano. Ad esempio i cookie possono analizzare quali sono le pagine più popolari del Sito;<br>
        permettere la gestione complessiva del Sito.<br><br>
        </p>

        <p><strong>ALTRE TIPOLOGIE DI COOKIE O STRUMENTI TERZI CHE POTREBBERO INSTALLARNE</strong><br />
        Alcuni dei servizi elencati di seguito raccolgono statistiche in forma aggregata ed anonima e potrebbero non richiedere il consenso dell'Utente o potrebbero essere gestiti direttamente dal Titolare – a seconda di quanto descritto – senza l'ausilio di terzi.<br>
        Qualora fra gli strumenti indicati in seguito fossero presenti servizi gestiti da terzi, questi potrebbero – in aggiunta a quanto specificato ed anche all’insaputa del Titolare – compiere attività di tracciamento dell’Utente. Per informazioni dettagliate in merito, si consiglia di consultare le privacy policy dei servizi elencati.
        <br><br>

        Hosting<br>
        Questo tipo di servizi ha la funzione di ospitare dati e file che permettono a questo Sito di funzionare, ne consentono la distribuzione e mettono a disposizione un'infrastruttura pronta all'uso per erogare specifiche funzionalità di questa Applicazione. Alcuni di questi servizi funzionano attraverso server dislocati geograficamente in luoghi differenti, rendendo difficile la determinazione del luogo esatto in cui vengono conservati i Dati Personali.
        <br><br>

        DigitalOcean, LLC<br>
        Dati Personali raccolti: Cookie e Dati di utilizzo.<br>
        Luogo del trattamento: Germania – <a href="https://www.digitalocean.com/legal/privacy-policy/">Privacy Policy</a>
        <br><br>

        Statistica<br>
        I servizi contenuti nella presente sezione permettono al Titolare del Trattamento di monitorare e analizzare i dati di traffico e servono a tener traccia del comportamento dell’Utente.
        <br><br>

        Google Analytics con IP anonimizzato (Google Inc.)<br>
        Google Analytics è un servizio di analisi web fornito da Google Inc. (“Google”). Google utilizza i Dati Personali raccolti allo scopo di tracciare ed esaminare l’utilizzo di questa Applicazione, compilare report e condividerli con gli altri servizi sviluppati da Google.<br>
        Google potrebbe utilizzare i Dati Personali per contestualizzare e personalizzare gli annunci del proprio network pubblicitario.<br>
        Questa integrazione di Google Analytics rende anonimo il tuo indirizzo IP. L'anonimizzazione funziona abbreviando entro i confini degli stati membri dell'Unione Europea o in altri Paesi aderenti all'accordo sullo Spazio Economico Europeo l'indirizzo IP degli Utenti. Solo in casi eccezionali, l'indirizzo IP sarà inviato ai server di Google ed abbreviato all'interno degli Stati Uniti.
        <br><br>

        Dati Personali raccolti: Cookie e Dati di utilizzo.<br>
        Luogo del trattamento: USA – <a href="https://policies.google.com/privacy?hl=it" target="_blank">Privacy Policy</a> – <a href="https://tools.google.com/dlpage/gaoptout?hl=it" target="_blank">Opt Out</a><br>
        Estensione User ID per Google Analytics (Google Inc.)
        <br><br>

        Google Analytics su questa Applicazione utilizza una funzione chiamata User ID. Questa permette un tracciamento più accurato degli Utenti assegnando ad ognuno un ID unico per varie sessioni e dispositivi, ma in modo tale da non permettere a Google di identificare in maniera personale un individuo o identificare in modo permanente uno specifico dispositivo. L’estensione User ID permette inoltre di connettere Dati provenienti da Google Analytics con altri Dati relativi all’utente raccolti da questa Applicazione.<br>
        Il link di Opt Out fornito di seguito consente di disattivare il tracciamento per il dispositivo che stai utilizzando, ma non esclude ulteriori attività di tracciamento effettuate dal Titolare. Per disattivare anche queste ultime, contatta il titolare tramite l’indirizzo email di contatto.<br>
        Dati Personali raccolti: Cookie.<br>
        Luogo del trattamento: USA – <a href="https://policies.google.com/privacy?hl=it" target="_blank">Privacy Policy</a> – <a href="https://tools.google.com/dlpage/gaoptout?hl=it" target="_blank">Opt Out</a>
        </p>

        <table class="tabella-pololab"><tbody><tr><th>Nome</th><th>Fornitore</th><th>Scopo</th><th>Scadenza</th><th>Tipo</th></tr><tr><td>cookies-consent</td><td>pololab.com</td><td>Memorizza lo stato del consenso ai cookie dell'utente per il dominio corrente.</td><td>Sessione<br></td><td>HTTP</td></tr><tr><td>_ga</td><td>pololab.com</td><td>Registra un ID univoco utilizzato per generare dati statistici su come il visitatore utilizza il sito internet.</td><td>2 anni</td><td>HTTP</td></tr><tr><td>_gid</td><td>pololab.com</td><td>Registra un ID univoco utilizzato per generare dati statistici su come il visitatore utilizza il sito internet.</td><td>Sessione</td><td>HTTP</td></tr><tr><td>_gat</td><td>pololab.com</td><td>Utilizzato da Google Analytics per limitare la frequenza delle richieste</td><td>Sessione</td><td>HTTP</td></tr><tr><td>__utma</td><td>pololab.com</td><td>Permette di stabilire il numero di visite di un utente sul sito.</td><td>2 anni</td><td>HTTP</td></tr><tr><td>__utmb</td><td>pololab.com</td><td>Cookie utilizzato per stabilire la durata della visita sul sito.</td><td>30 min.<br></td><td>HTTP</td></tr><tr><td>__utmc</td><td>pololab.com</td><td>Utilizzato in unione __utmb per stabilire la durata della visita sul sito.</td><td>Sessione</td><td>HTTP</td></tr><tr><td>__utmt</td><td>pololab.com</td><td>Utilizzato per stabilire il tipo della richiesta</td><td>10 min<br></td><td>HTTP</td></tr><tr><td>__utmz</td><td>pololab.com</td><td>Permette di stabilire la provenienza dell'utente Internet</td><td>6 mesi<br></td><td>HTTP</td></tr><tr><td>__utmv</td><td>pololab.com</td><td>Conserva i dati variabili di livello-visitatore. Il cookie viene aggiornato ogni volta che vengono inviati dati a Google Analytics</td><td>2 mesi<br></td><td>HTTP</td></tr><tr><td>aka_debug</td><td>player.vimeo.com</td><td>Questi cookies sono installati attraverso i video embed di Vimeo. Registrano statistiche anonime sulla visualizzazione dei video da parte degli utenti e i settaggi di visualizzazione.</td><td>2 anni<br></td><td>HTTP</td></tr></tbody></table>

        <p><strong>COME POSSO CONTROLLARE L'INSTALLAZIONE DI COOKIE?</strong><br />
        Ogni browser moderno dà la possibilità all’utente, in aggiunta a quanto indicato in questo documento, di gestire le preferenze relative ai Cookie. È possibile eliminare i Cookie installati in passato, ad esempio il Cookie in cui viene salvato il consenso all'installazione di Cookie da parte di questo sito. Il Titolare non assicura la piena fruizione dei servizi del sito qualora l’utente disabiliti completamente l’installazione di cookie. Ulteriori informazioni su come gestire i Cookie nei diversi browser:
        <a href="https://support.google.com/chrome/answer/95647?hl=it&amp;p=cpn_cookies" target="_blank">Google Chrome</a>, <a href="https://support.mozilla.org/it/kb/Attivare%20e%20disattivare%20i%20cookie" target="_blank">Mozilla Firefox</a>, <a href="https://support.apple.com/kb/PH21411" target="_blank">Apple Safari</a>, <a href="http://windows.microsoft.com/it-it/windows-vista/block-or-allow-cookies" target="_blank">Microsoft Windows Explorer</a>. Nel caso di cookie di terze parti, l'utente può negare il consenso al tracciamento informandosi nella privacy policy della terza parte e, se presente, tramite il link di opt out (o contattando il soggetto in modo diretto).
        </p>

        <p><strong>TITOLARE DEL TRATTAMENTO DEI DATI</strong><br />

        Laboratorio Polo - Via Verdi, 32 - 31046 - Oderzo - TV - (Italy)
        Indirizzo email del Titolare: <a href="mailto:info@pololab.com">info@pololab.com</a><br><br>
        Dal momento che l'installazione di Cookie e di altri sistemi di tracciamento operata da terze parti tramite i servizi utilizzati all'interno di questo Sito non può essere tecnicamente controllata dal Titolare, ogni riferimento specifico a Cookie e sistemi di tracciamento installati da terze parti è da considerarsi indicativo. Per ottenere informazioni complete, l’Utente è invitato a consultare la privacy policy degli eventuali servizi terzi elencati in questo documento.<br>
        Vista l'oggettiva complessità di identificazione delle tecnologie basate sui Cookie l'Utente è invitato a contattare il Titolare qualora volesse ricevere qualunque approfondimento relativo all'utilizzo dei Cookie stessi tramite questa Applicazione.
        </p>

        <p><strong>DEFINIZIONI E RIFERIMENTI LEGALI</strong><br />
        DATI PERSONALI<br>
        Sono dati personali le informazioni che identificano o rendono identificabile una persona fisica e che possono fornire dettagli sulle sue caratteristiche, le sue abitudini, il suo stile di vita, le sue relazioni personali, il suo stato di salute, la sua situazione economica, ecc..
        <br><br>

        DATI DI UTILIZZO<br>
        Sono i dati personali raccolti in maniera automatica:<br>
        indirizzi IP o i nomi a dominio dei computer utilizzati dall’Utente che si connette al sito, gli indirizzi in notazione URI (Uniform Resource Identifier),<br>
        l’orario della richiesta,<br>
        il metodo utilizzato nel sottoporre la richiesta al server,<br>
        la dimensione del file ottenuto in risposta,<br>
        il codice numerico indicante lo stato della risposta dal server (buon fine, errore, ecc.)<br>
        il Paese di provenienza,<br>
        le caratteristiche del browser e del sistema operativo utilizzati dal visitatore,<br>
        le varie connotazioni temporali della visita (ad esempio il tempo di permanenza su ciascuna pagina) e i dettagli relativi all’itinerario seguito all’interno del sito, con particolare riferimento alla sequenza delle pagine consultate, ai parametri relativi al sistema operativo e all’ambiente informatico dell’Utente.
        <br><br>

        UTENTE<br>
        L'individuo che utilizza il sito ed i cui dati personali sono oggetto del trattamento.
        <br><br>

        INTERESSATO<br>
        La persona fisica o giuridica cui si riferiscono i Dati Personali.
        <br><br>

        RESPONSABILE DEL TRATTAMENTO (O RESPONSABILE)<br>
        La persona fisica, giuridica, la pubblica amministrazione e qualsiasi altro ente, associazione od organismo preposti dal Titolare al trattamento dei Dati Personali, secondo quanto predisposto dalla presente privacy policy.
        <br><br>

        TITOLARE DEL TRATTAMENTO (O TITOLARE)<br>
        La persona fisica, giuridica, la pubblica amministrazione e qualsiasi altro ente, associazione od organismo cui competono, anche unitamente ad altro titolare, le decisioni in ordine alle finalità, alle modalità del trattamento di dati personali ed agli strumenti utilizzati, ivi compreso il profilo della sicurezza, in relazione al funzionamento e alla fruizione di questo sito. Il Titolare del trattamento, salvo quanto diversamente specificato, è il proprietario di questo sito.
        <br><br>

        QUESTO SITO<br>
        Lo strumento hardware o software mediante il quale sono raccolti i Dati Personali degli utenti.
        <br><br>

        COOKIE<br>
        Piccola porzione di dati conservata all'interno del dispositivo dell’Utente.
        <br><br>

        RIFERIMENTI LEGALI<br>
        La presente informativa privacy è redatta sulla base di molteplici ordinamenti legislativi, inclusi gli artt. 13 e 14 del Regolamento (UE) 2016/679.<br> Questa informativa privacy riguarda esclusivamente questo sito.
        <br><br>

        </p>

      </div>
    </div>

    <global-footer />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import GlobalFooter from '../components/GlobalFooter'

export default {
  components: {
    GlobalFooter
  },
  data: () => ({
    logos: require('./Referenze/lista-loghi.json')
  }),
  methods: {
    ...mapMutations('animations', [
      'updateMouseCursor'
    ])
  }
}
</script>

<style lang="scss">

@import '../assets/scss/breakpoint.scss';

$marginLeftRight: 7.5%;
$marginLeftRightDesktop: 15%;
$marginBottom: 15%;

.policy {
  background: linear-gradient(0deg, #0487a3, #0b3277 70%);
  position: relative;
  box-sizing: border-box;
  .hero-block__wrap{
    position: relative;
    height: 60vh;
    padding-top: 6.25%;
    min-height: 400px;
    transform: none;
  }
}

.istit__content{

  @include media(">=large"){
    width: 85%;
  }
  @include media(">=xlarge"){
    width: 75%;
  }

}

.istit__content__inner{
  box-sizing: border-box;
  padding-left: $marginLeftRight;
  padding-right: $marginLeftRight;
  margin-bottom: 15rem;

  h2{
    margin-bottom: 6rem;
    font-size: 1.6rem;
    color: #f2f2f2;
    text-transform: uppercase;
    font-weight: 600;
  }
  p{
    font-size: 1.6rem;
    line-height: 2;
    color: #f2f2f2;
  }
  p + p{
    margin-top: 4rem;
    @include media(">=large"){
      margin-top: 3rem;
    }
  }
  p + h2{
    margin-top: 10rem;
    /*@include media(">=large"){
      margin-bottom: 18rem;
    }*/
  }
  strong{
    font-weight: 600;
  }

  @include media(">=large"){
    padding-left: $marginLeftRightDesktop;
    padding-right: $marginLeftRightDesktop;
  }
  @include media(">=xlarge"){
    p{
      font-size: 1.8rem;
    }
  }
}

.tabella-pololab{
  width: 80%;
  margin: 5rem 0 8rem;

  tbody tr{
    background-color: rgba(255, 255, 255, 0.2);
  }

  tbody tr:nth-child(2n){
    background-color: rgba(255, 255, 255, 0.1);
  }

  th, td{
    padding: .9rem 1.25rem 1.25rem;
    font-size: 1.4rem;
    line-height: 1.4;
    color: #f2f2f2;
  }

}

</style>
